import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { memo, useEffect, useMemo } from "react";
import CompanyFspFormPanel from "./CompanyFspFormPanel";
import ChargeSuppleTermsFormPanel from "./ChargeSuppleTermsFormPanel";
import CompanyEmptyPoolFormPanel from "./CompanyEmptyPoolFormPanel";
import CompanyTeuFactorFormPanel from "./CompanyTeuFactorFormPanel";
import CustomerAssignmentFormPanel from "./CustomerAssignmentFormPanel";
import CustomerInformationFormPanel from "./CustomerInformationFormPanel";
import { useCompanyMaintenanceTracked } from "presentation/store/Company/CompanyMaintenanceProvider";
import CompanyBatchUpdatePanel from "./CompanyBatchUpdatePanel";
import CompanyDockageFormPanel from "./CompanyDockageFormPanel";

const CompanyDetailFormPanel = () => {
    const [companyDtlState, setCompanyDtlState] = useCompanyDetailTracked();
    const [companyState] = useCompanyMaintenanceTracked();
    const { isShowDetail } = companyState
    const { isShowCustAssign, isShowFactor, isShowFsp, isShowEmptyPool, isShowSuppleTerms, isShowCustInfo, isShowFspBulkEdit, isShowDockage } = companyDtlState.viewState

    useEffect(() => {
        if (isShowDetail || isShowFsp || isShowSuppleTerms || isShowCustAssign || isShowEmptyPool || isShowFactor || isShowCustInfo || isShowFspBulkEdit || isShowDockage) {
            setCompanyDtlState(prevState => ({
                ...prevState,
                companyId: companyState.currentCompany.id
            }))
        }
    }, [companyState.currentCompany.id, isShowCustAssign, isShowCustInfo, isShowDetail, isShowEmptyPool, isShowFactor, isShowFsp, isShowSuppleTerms, isShowFspBulkEdit, isShowDockage, setCompanyDtlState])

    const memoCompanyFspForm = useMemo(() => {
        return <CompanyFspFormPanel />
    }, [])

    const memoChgSuppleTermsForm = useMemo(() => {
        return <ChargeSuppleTermsFormPanel />
    }, [])

    const memoEmptyPoolForm = useMemo(() => {
        return <CompanyEmptyPoolFormPanel />
    }, [])

    const memoTeuFactorForm = useMemo(() => {
        return <CompanyTeuFactorFormPanel />
    }, [])

    const memoCustomerAssignForm = useMemo(() => {
        return <CustomerAssignmentFormPanel />
    }, [])

    const memoCustomerInfoForm = useMemo(() => {
        return <CustomerInformationFormPanel />
    }, [])

    const memoCompanyFspBulkEdieForm = useMemo(() => {
        return <CompanyBatchUpdatePanel />
    }, [])

    const memoDockage = useMemo(() => {
        return <CompanyDockageFormPanel />
    }, [])

    return (
        <>
            {isShowFsp && <>{memoCompanyFspForm}</>}
            {isShowSuppleTerms && <>{memoChgSuppleTermsForm}</>}
            {isShowCustAssign && <>{memoCustomerAssignForm}</>}
            {isShowEmptyPool && <>{memoEmptyPoolForm}</>}
            {isShowFactor && <>{memoTeuFactorForm}</>}
            {isShowCustInfo && <>{memoCustomerInfoForm}</>}
            {isShowFspBulkEdit && <>{memoCompanyFspBulkEdieForm}</>}
            {isShowDockage && <>{memoDockage}</>}
        </>
    )
}
export default memo(CompanyDetailFormPanel);